// @flow

import ApiObject from '../ApiObject';
import RestaurantDashboardInfoBooking from './RestaurantDashboardInfoBooking';

export default class RestaurantDashboardInfo extends ApiObject {

  booking: RestaurantDashboardInfoBooking = new RestaurantDashboardInfoBooking();

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    this.booking = new RestaurantDashboardInfoBooking();
    this.booking.fromJson(data.booking);
  }

}
